export const formatNumber = (num: number | string | null | undefined): string => {
  if (num === null || num === undefined) {
    return '0';
  }

  const number = typeof num === 'string' ? parseFloat(num) : num;
  return Number.isFinite(number) ? number.toLocaleString() : '0';
};